module.exports = __webpack_public_path__ + "static/nectar-beanie-df9b8e6663cec4aba74b9accda321b93.jpg";